import React from "react";

export default ({number}) => (
    <h2 style={{ marginTop: "0" }}>
        {`Заказ №${number}`}
    </h2>
)


// WEBPACK FOOTER //
// ./src/components/MakeOrder/LeftSideOrderNumber.js